import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Spin } from "antd";
import { useTranslation } from "react-i18next"; // ✅ import i18n hook
import Loader from "../../components/loader/loader";

export default function ResetPassword() {
  const { t } = useTranslation(); // ✅ initialize translation
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [searchParams] = useSearchParams();
  const { token } = useParams();
  const email = searchParams.get("email");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingReset, setIsLoadingReset] = useState(false);

  useEffect(() => {
    const checkToken = () => {
      const authToken = localStorage.getItem("authToken");
      if (authToken) {
        navigate("/", { replace: true });
      }
    };
    const interval = setInterval(checkToken, 1000);
    return () => clearInterval(interval);
  }, [navigate]);

  useEffect(() => {
    const handleLoad = () => {
      const authToken = localStorage.getItem("authToken");
      if (authToken) {
        navigate("/");
      } else {
        setIsLoading(false);
      }
    };

    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  const handleReset = async () => {
    if (!password) {
      toast.error(t("Please enter your new password"));
      return;
    }

    if (password !== confirmPassword) {
      toast.error(t("Passwords do not match"));
      return;
    }

    setIsLoadingReset(true);

    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/reset-password`, {
        token,
        email,
        password,
        password_confirmation: confirmPassword,
      });

      toast.success(res.data.message || t("Password reset successfully"));
      navigate("/signin");
    } catch (error) {
      toast.error(error.response?.data?.message || t("Failed to reset password"));
    } finally {
      setIsLoadingReset(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Loader />
        </div>
      ) : (
        <div>
          <section className="bg-sign-in">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6 pb-5">
                  <div className="sign-in-form">
                    <h2>{t("RESET PASSWORD")}</h2>
                    <p>{t("Please enter your new password")}</p>
                    <form action="#" id="contactform">
                      <fieldset>
                        <input
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          id="password"
                          name="password"
                          tabIndex="1"
                          aria-required="true"
                          required
                          type="password"
                          placeholder={t("New Password")}
                        />
                      </fieldset>
                      <fieldset>
                        <input
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          id="confirmPassword"
                          name="confirmPassword"
                          tabIndex="2"
                          aria-required="true"
                          required
                          type="password"
                          placeholder={t("Confirm Password")}
                        />
                      </fieldset>
                      <button
                        onClick={handleReset}
                        className="tf-button submit"
                        type="button"
                        disabled={isLoadingReset}
                      >
                        {isLoadingReset ? <Spin /> : t("RESET PASSWORD")}
                      </button>
                    </form>
                    <div className="choose-sign">
                      {t("Remember your password?")}{" "}
                      <Link to="/login">{t("Sign in")}</Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
          </section>
          <ToastContainer draggable />
        </div>
      )}
    </>
  );
}
